export const OBJECT_SUMMARY = 'object_summary';
export const AUDIT_LOG_SUMMARY = 'audit_log_summary';
export const OBJECT_UPDATE = 'object_update';
export const COMPANY_NEWS = 'news';
export const SUMMARIZE_ARTICLE = 'summarize_article';
export const COMPANY_TECH = 'company_tech';
export const COMMUNICATION_SUMMARY = 'communication_summary';
export const OBJECT_ENGAGEMENTS_SUMMARY = 'object_engagements_summary';
export const TASK_CREATE = 'task_create';
export const SUMMARIZE_ACTIVITY_FEED = 'summarize_activity_feed';
export const WORKFLOW_CREATE = 'workflow_create';
export const WORKFLOW_GENERATION = 'workflow_generation';
export const OBJECT_ASSOCIATIONS = 'object_associations';
export const REPORTING_INSIGHTS_COPILOT_GENERATION = 'reporting_insights_copilot_generation';
export const MARKETPLACE = 'marketplace';
export const FEEDBACK_SUBMISSION_SUMMARY = 'feedback_submission_summary';
export const INVOICES_CREATE = 'invoices_create';
export const HUBSPOT_HOW_TO = 'hubspot_how_to';
export const TEXT_GENERATION = 'text_generate';
export const CONTENT_REWRITE = 'content_rewrite';
export const CALL_SUMMARY = 'call_summary';